import { Component } from '@angular/core';

@Component({
  selector: 'app-detail-prescription-hospit',
  imports: [],
  templateUrl: './detail-prescription-hospit.component.html',
  styleUrl: './detail-prescription-hospit.component.scss'
})
export class DetailPrescriptionHospitComponent {

}
